function GetAttr (attr) {
  return attr.substring(1, attr.length - 1)
}

export { GetAttr }
